import { createSvgIcon } from "@mui/material/utils";
import React from "react";

export const IconFileTypeDefault = createSvgIcon(
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7 3.5C6.60218 3.5 6.22064 3.65804 5.93934 3.93934C5.65804 4.22064 5.5 4.60218 5.5 5V19C5.5 19.3978 5.65804 19.7794 5.93934 20.0607C6.22064 20.342 6.60218 20.5 7 20.5H17C17.3978 20.5 17.7794 20.342 18.0607 20.0607C18.342 19.7794 18.5 19.3978 18.5 19V9.41411V9.41411C18.4999 9.28155 18.4473 9.15433 18.3535 9.06061L12.9394 3.64655C12.8457 3.5528 12.7186 3.50006 12.586 3.5V3.5H7ZM5.23223 3.23223C5.70107 2.76339 6.33696 2.5 7 2.5H12.586C12.9838 2.50008 13.3653 2.65816 13.6466 2.93945M13.6466 2.93945L19.0605 8.35339V8.35339C19.3418 8.63463 19.4999 9.01613 19.5 9.41389V19C19.5 19.663 19.2366 20.2989 18.7678 20.7678C18.2989 21.2366 17.663 21.5 17 21.5H7C6.33696 21.5 5.70107 21.2366 5.23223 20.7678C4.76339 20.2989 4.5 19.663 4.5 19V5C4.5 4.33696 4.76339 3.70107 5.23223 3.23223"
      fill="#4A5568"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13.1213 9.51493C13.3892 9.5819 13.552 9.85337 13.4851 10.1213L11.4851 18.1213C11.4181 18.3892 11.1466 18.552 10.8787 18.4851C10.6108 18.4181 10.448 18.1466 10.5149 17.8787L12.5149 9.87873C12.5819 9.61083 12.8534 9.44795 13.1213 9.51493ZM9.35355 11.6464C9.54882 11.8417 9.54882 12.1583 9.35355 12.3536L7.70711 14L9.35355 15.6464C9.54882 15.8417 9.54882 16.1583 9.35355 16.3536C9.15829 16.5488 8.84171 16.5488 8.64645 16.3536L6.64645 14.3536C6.45118 14.1583 6.45118 13.8417 6.64645 13.6464L8.64645 11.6464C8.84171 11.4512 9.15829 11.4512 9.35355 11.6464ZM14.6464 11.6464C14.8417 11.4512 15.1583 11.4512 15.3536 11.6464L17.3536 13.6464C17.5488 13.8417 17.5488 14.1583 17.3536 14.3536L15.3536 16.3536C15.1583 16.5488 14.8417 16.5488 14.6464 16.3536C14.4512 16.1583 14.4512 15.8417 14.6464 15.6464L16.2929 14L14.6464 12.3536C14.4512 12.1583 14.4512 11.8417 14.6464 11.6464Z"
      fill="#4A5568"
    />
  </svg>,
  "IconFileTypeDefault",
);
